import type { SVGProps } from 'react';

export const SparkleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M17.66 6.34114L22.0333 8.07047C22.4159 8.22113 22.6653 8.59047 22.6653 8.9998C22.6653 9.40913 22.4133 9.77846 22.0319 9.92913L17.6586 11.6585L15.928 16.0331C15.7773 16.4144 15.408 16.6651 14.9986 16.6651C14.5893 16.6651 14.22 16.4144 14.0693 16.0331L12.3386 11.6585L7.96532 9.92913C7.58265 9.77846 7.33199 9.40913 7.33199 8.9998C7.33199 8.59047 7.58399 8.22113 7.96532 8.07047L12.3386 6.34114L14.0693 1.96648C14.372 1.20382 15.6266 1.20382 15.9293 1.96648L17.66 6.34114ZM8.23598 15.7625L10.7 16.7371C11.0826 16.8878 11.332 17.2571 11.332 17.6665C11.332 18.0758 11.08 18.4451 10.6986 18.5958L8.23465 19.5705L7.26132 22.0344C7.11065 22.4158 6.74132 22.6664 6.33199 22.6664C5.92266 22.6664 5.55332 22.4158 5.40266 22.0344L4.42933 19.5705L1.96533 18.5958C1.58267 18.4451 1.332 18.0758 1.332 17.6665C1.332 17.2571 1.584 16.8878 1.96533 16.7371L4.42933 15.7625L5.40266 13.2985C5.70532 12.5358 6.95999 12.5358 7.26265 13.2985L8.23598 15.7625Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
